export default __webpack_public_path__ + "static/media/photo--lg--game-night.0270fbe9.jpg";